export default __webpack_public_path__ + "static/media/bus2.a9316523.jpg";